import menuPages from './menus/pages.menu';

export default {
  // main navigation - side menu
  menu: menuPages,
};
